module.exports = __webpack_public_path__ + "static/the-lessons-of-history-8f562e033270fdaa17ef8a076d04ec11.jpg";